/**
* @license Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
* For licensing, see LICENSE.md or http://ckeditor.com/license
*/

// Save Footnote
(() => {
    CKEDITOR.plugins.add('saveFootnotes', {
		// icons: 'save', // %REMOVE_LINE_CORE%
        hidpi: true, // %REMOVE_LINE_CORE%
        init(editor) {
			// store.commit('paperEdit/autoSave/START_TIMER');

            editor.addCommand('saveFootnotes', {
                exec(editor) {
                    if (editor.fire('saveFootnotes')) {
						// emit directly back to the CitationEdit.vue component that has a listener for this
						window.$vm.emitter.emit('saveOpenFootnote');
                    }
                }//e:exec
            }); // end addCommand save

            editor.ui.addButton('Save', {
				label: 'Save',
                command: 'saveFootnotes',
            });

            editor.on('destroy', () => {
				// store.commit('paperEdit/autoSave/CLEAR_TIMER');
            });

            editor.setKeystroke(CKEDITOR.CTRL + 83 /*S*/, 'saveFootnotes');
        }//e:init
    });//e:plugins.add

})();